export const termsConditionsDefault = {
  title: "Terms & Conditions – Superhost App",
  effective_date: "01 April 2026",
  intro:
    "These Terms & Conditions (\"Terms\") govern your access to and use of the Superhost App and related services provided by Superhost Cloud (\"we\", \"our\", \"us\"). By using the app, you agree to these Terms. Please read them carefully.",
  sections: [
    {
      heading: "Purpose of the Service",
      body:
        "The Superhost App helps accommodation owners and managers list, manage, and grow their properties — including managing bookings, OTA listings, pricing, guest communication, and related hospitality operations. The service is provided to support your business operations.",
    },
    {
      heading: "User Eligibility",
      body:
        "You must be at least 18 years old and legally capable of entering into a binding agreement to use the app. By using the service, you represent that you meet these requirements and that any business information you provide is accurate and authorised.",
    },
    {
      heading: "Account Responsibility",
      body:
        "You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. You must notify us immediately of any unauthorised use or suspected security breach. We are not liable for any loss arising from your failure to safeguard your account.",
    },
    {
      heading: "Acceptable Use",
      body:
        "You agree to use the app only for lawful purposes and in accordance with these Terms. You must not misuse the service, attempt to gain unauthorised access, upload malicious code, interfere with its operation, or use it to infringe the rights of others or violate any applicable law.",
    },
    {
      heading: "Booking & Property Data",
      body:
        "You are responsible for the accuracy of the booking, pricing, availability, and property information you enter into the app. We are not responsible for losses, overbookings, or disputes resulting from incorrect or outdated information provided by you.",
    },
    {
      heading: "Guest Identity Documents",
      body:
        "If you collect or upload guest identity or verification documents through the app, you confirm that you have the necessary consent and legal basis to do so. Such documents must be handled in compliance with applicable laws, and you remain responsible for their lawful use.",
    },
    {
      heading: "Notifications & Communication",
      body:
        "By using the app, you agree to receive service-related notifications, alerts, and communications regarding bookings, enquiries, updates, and account activity. Some communications are essential to the service and cannot be opted out of while your account remains active.",
    },
    {
      heading: "Third-Party Services",
      body:
        "The app may integrate with third-party services such as OTAs, payment processors, messaging platforms, and analytics tools. Your use of those services is subject to their own terms and policies. We are not responsible for the availability, accuracy, or conduct of third-party services.",
    },
    {
      heading: "OTA & External Service Disclaimer",
      body:
        "While we work to synchronise your listings and bookings across online travel agencies (OTAs) and external platforms, we do not control those platforms. We are not liable for changes, errors, delays, downtime, or policy decisions made by OTAs or other external services.",
    },
    {
      heading: "Service Availability",
      body:
        "We strive to keep the service available and reliable, but we do not guarantee uninterrupted or error-free operation. The service is provided on an \"as is\" and \"as available\" basis, and access may be affected by factors beyond our control.",
    },
    {
      heading: "Account Suspension & Termination",
      body:
        "We may temporarily suspend or restrict access to the service for maintenance, upgrades, security, or technical reasons. We will make reasonable efforts to minimise disruption but are not liable for any interruption to the service.",
    },
    {
      heading: "Account Suspension & Termination",
      body:
        "We may suspend or terminate your account, with or without notice, if you violate these Terms, misuse the service, or engage in unlawful or harmful activity. Upon termination, your right to use the app ceases immediately, though certain provisions survive termination.",
    },
    {
      heading: "Intellectual Property",
      body:
        "All rights, title, and interest in the Superhost App — including its software, design, branding, and content (excluding your own data) — belong to Superhost Cloud or its licensors. You may not copy, modify, distribute, or create derivative works without our written permission.",
    },
    {
      heading: "Limitation of Liability",
      body:
        "To the maximum extent permitted by law, Superhost Cloud shall not be liable for any indirect, incidental, special, or consequential damages, or for any loss of profits, revenue, data, or bookings arising from your use of or inability to use the service.",
    },
    {
      heading: "Changes to These Terms",
      body:
        "We may update these Terms from time to time to reflect changes in our service or legal requirements. When we make material changes, we will update the effective date and, where appropriate, notify you through the app or by email. Continued use of the app constitutes acceptance of the updated Terms.",
    },
    {
      heading: "Governing Law",
      body:
        "These Terms are governed by and construed in accordance with the laws of India. Any disputes arising from or relating to these Terms or the service shall be subject to the exclusive jurisdiction of the competent courts in India.",
    },
    {
      heading: "Severability",
      body:
        "If any provision of these Terms is found to be invalid or unenforceable, that provision shall be limited or removed to the minimum extent necessary, and the remaining provisions shall continue in full force and effect.",
    },
    {
      heading: "Contact Us",
      body:
        "If you have any questions about these Terms, please contact us at:\nEmail: support@superhostcloud.com",
    },
    {
      heading: "Acceptance",
      body:
        "By downloading, accessing, or using the Superhost App, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions.",
    },
  ],
};
